import React from 'react';
import { Box } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import { formatYearsOfExperience } from '../data/experience';
import SectionHeading from './section-heading';
import './styles/about.css';

export default function AboutMe() {
  // Scanned rather than read — keep it to facts the rest of the page backs up
  const glance = [
    { label: 'Role', value: 'Senior Software Developer' },
    { label: 'Company', value: 'Metamedia Technology Co., Ltd.' },
    { label: 'Focus', value: 'Full-stack web · Vue · Nuxt · Python' },
    { label: 'Degree', value: 'B.Eng. Computer Engineering, KMITL' },
  ];

  const fade = {
    visible: { opacity: 1, y: 0 },
    hidden: { opacity: 0, y: 16 },
  };

  return (
    <Box mt={'30px'}>
      <SectionHeading index="01">About Me</SectionHeading>

      <div className="about">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.5, ease: 'easeOut' }}
          variants={fade}
        >
          <p className="about__lead">
            I'm a <span className="about__mark">Full-Stack Developer</span> with{' '}
            <span className="about__accent">{formatYearsOfExperience()}</span> of
            experience in web development. I am proficient in various programming
            languages, frameworks, and technologies, including HTML, CSS,
            JavaScript, Vue.js, Nuxt.js, Drupal, PHP, Python and others.
          </p>
          <p className="about__lead">
            I'm also experienced in working with{' '}
            <span className="about__mark">AI assistants</span> as part of my daily
            development workflow, using them for coding, code review, and
            debugging to ship better work faster.
          </p>
        </motion.div>

        <motion.div
          className="panel about__card"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.5, delay: 0.12, ease: 'easeOut' }}
          variants={fade}
        >
          <div className="eyebrow about__card-title">At a glance</div>
          {glance.map(item => (
            <div className="about__row" key={item.label}>
              <span className="about__label">{item.label}</span>
              <span className="about__value">{item.value}</span>
            </div>
          ))}
        </motion.div>
      </div>
    </Box>
  );
}
